/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import './qrPage.scss'

import Menu from '../../components/Menu'

import foodIcon from '../../assets/svg/qrIcon.svg'
import qrCodeSite from '../../assets/svg/qr.svg'

import { notify } from '../../components/Toast'
import { get } from '../../services/http'

export default function index() {
  document.title = 'کیوآرکد'

  const [foods, setFoods] = useState([])
  const [foodId, setFoodId] = useState('')
  const [qrCode, setQrcode] = useState('')

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/foods/qr/all?token=${token}`)
      .then(response => {
        setFoods(response.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const foodSelectHandler = (e) => {
    setFoodId(e.target.value)
  }

  const qrCodeMaker = () => {
    if(foodId.length >= 5) {
      get(`/api/admin/qrcode/${foodId}?token=${token}`)
        .then(response => {
          console.log(response)
          setQrcode(response.data.data)
        }).catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  return (
    <main id='panel'>
      <Menu page={'qr'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='icon'>
                <img src={foodIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                کد QR
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <div className='form'>
            <div className="row">
              <div className='column'>
                <div className='qrSection' style={{ margin: 'auto' }}>
                  <div className='text'>
                    <span>کیوآرکد</span>
                  </div>
                  <hr />
                  <div className='qr'>
                    <img src={qrCodeSite} width={'250px'} alt='qr' />
                  </div>
                  <hr />
                  <div className='suggestText'>
                    با استفاده از دوربین خود اسکن کنید
                  </div>
                </div>
              </div>
              <div className='column' style={{ width: 'auto' }}>
                <button>چاپ</button>
              </div>
            </div>
            <div className='lineTitle'>
              <hr />
              تولید کیوآرکد‌
              <hr />
            </div>
            <div className="row" style={{ justifyContent: 'flex-start' }}>
              <div className='column'>
                <label htmlFor='foodPrice' className='settinInput'>
                  <span>
                    انتخاب آیتم * :
                  </span>
                </label>
                <select id='categoryName' onChange={foodSelectHandler}>
                  <option value='0'>انتخاب کنید</option>
                  {foods ? foods.map((item, index) => (
                    <option key={index} value={item._id}>{item.name}</option>
                  )) : ''}
                </select>
                <small id='foodPriceAlert'>باید یک مورد انتخاب شود</small>
              </div>
              <div className='column' style={{ justifyContent: 'end', width: 'auto' }}>
                <button onClick={qrCodeMaker}>تولید QR</button>
              </div>
            </div>
            <img src={qrCode} alt='qrcode' style={ qrCode.length < 5 ? { display: 'none' } : { display: '' } } />
          </div>
          <button className='createButton'>ثبت تغییرات</button>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
